import React from "react";
import styled from "styled-components";
import { getNetworkStatusIframeSrc } from "@helpers";

const Iframe = styled.iframe`
  /* box-shadow: 0 4px 15px 0 rgba(18, 18, 82, 0.2); */
  width: 100%;
  min-height: 500px;
  @media (min-width: 768px) {
    min-height: 600px;
  }
`;

const OutagePageIframe = () => {
	const iframeSrc = getNetworkStatusIframeSrc();

	return (
		<Iframe
			id="network-status-iframe"
			allow="geolocation *;"
			src={iframeSrc}
			frameBorder="0"
			title="outage coverage map"
			data-gtm-cta-position="outage coverage map"
			data-gtm-cta-text={iframeSrc}
			scrolling="no"
			allowfullscreen
		/>
	);
};

export default OutagePageIframe;
